<template>
  <div class="map-link">
    <!-- Static map image -->
    <img
      v-if="imgUrl"
      class="map-link__img"
      loading="lazy"
      :alt="title"
      :src="imgUrl"
      :title="title"
      :height="height"
      :width="width"
    />
    <!-- Link to Google Maps -->
    <a v-if="mapUrl" class="map-link__link" target="_blank" rel="noopener" :href="mapUrl" :title="title" />
  </div>
</template>

<script>
const mapActionUrl = 'https://www.google.com/maps/search/?api=1'
const mapStaticUrl = 'https://maps.googleapis.com/maps/api/staticmap'

export default {
  computed: {
    center() {
      return `${this.lat},${this.lng}`
    },

    /**
     * Google Maps static image URL,
     * ref: https://developers.google.com/maps/documentation/maps-static/dev-guide#location
     */
    imgUrl() {
      if (this.imageUrl) {
        return this.imageUrl
      } else if (this.zoom) {
        const key = process.env.SEEKER_WEB__GMAPS_KEY
        const size = `${this.width}x${this.height}`
        const marker = `color:red|size:mid|${this.center}`
        return `${mapStaticUrl}?scale=2&maptype=roadmap&language=en&key=${key}&size=${size}&zoom=${this.zoom}&center=${this.center}&markers=${marker}`
      }
      return ''
    },

    /**
     * Google Maps search action URL,
     * ref: https://developers.google.com/maps/documentation/urls/guide#search-action
     */
    mapUrl() {
      return `${mapActionUrl}&query=${this.center}`
    },

    title() {
      return this.$t('jobDetail.mapLink')
    },
  },
  props: {
    height: {
      default: 136,
      type: Number,
    },
    imageUrl: {
      default: null,
      type: String,
    },
    lat: {
      required: true,
      type: Number,
    },
    lng: {
      required: true,
      type: Number,
    },
    width: {
      default: 600,
      type: Number,
    },
    zoom: {
      default: 14,
      type: Number,
    },
  },
}
</script>

<style lang="postcss" scoped>
.map-link {
  @apply relative rounded-md overflow-hidden;
}
.map-link__img {
  @apply relative w-full h-full object-cover z-0;
}
.map-link__link {
  @apply absolute inset-0 bg-grey opacity-0 z-1;
  transition: opacity 0.2s ease;

  &:hover {
    @apply opacity-10;
  }
}
</style>
